import { Tooltip } from '@mui/material';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import categoryApi from '../api/categories';
import { MdKeyboardArrowDown } from 'react-icons/md';
import {
  ARROWDOWN_ICON,
  BACK_ARROW,
  DEFAULT_PROFILE_PIC,
  FEEDBACK_ICON,
  LOGOUT_ICON,
  MESSAGE_SVG,
  NOTIFICATIONS_SVG,
  PERSON_ICON,
  RECEIPT_ICON,
  SEARCH_SVG,
  SETTINGS_ICON
} from '../assets/icons';
import  NAV_LOGO  from '../assets/logos/World_O_Tutor.webp';
import { useAppDispatch, useAppSelector } from '../hooks';
import MenuDropDown from './MenuDropDown';
import authApi from '../api/auth';
import { login } from '../reducers/authSlice';
import { setUserProfile } from '../reducers/userSlice';
import BottomNav from './BottomNav';
import BreadCrumb from './BreadCrumb';
import { capitalizeFirstLetter } from '../utils/functions';
import xhr, { ApiError } from '../utils/fetch';
import { notificationsApi } from '../api/notifications';

export function Header({
  sidebarOpen,
  onOpenSidebar,
  onCloseSidebar
}: {
  sidebarOpen: any;
  onOpenSidebar: any;
  onCloseSidebar: any;
}) {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { userData } = useAppSelector((state) => state.userSlice);
  const [subjects, setSubjects] = useState([]);
  const [hobbies, setHobbies] = useState([]);
  const [skills, setSkills] = useState([]);
  const [path, setPath] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { planId, id } = useParams();

  const [showHeader, setShowHeader] = useState({ show: true, scrollPos: 0 });
  const headerRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (window.scrollY < 100) {
      setShowHeader(() => ({ ...showHeader, show: true }));
    } else {
      setShowHeader((prev) => ({
        scrollPos: document.body.getBoundingClientRect().top,
        show: document.body.getBoundingClientRect().top > prev.scrollPos
      }));
    }
  };

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  useEffect(() => {

  })

  useEffect(() => {
    setPath(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    categoryApi.getCategoriesByType('subject').then((data) => {
      setSubjects(data);
    });

    categoryApi.getCategoriesByType('hobby').then((data) => {
      setHobbies(data);
    });

    categoryApi.getCategoriesByType('skill').then((data) => {
      setSkills(data);
    });
  }, []);

  const logout = async () => {
    await authApi.logout().catch((err) => err);
    dispatch(login(null));
    dispatch(setUserProfile(null));
  };

  const paths = [
    '/account/profile',
    '/account/transactions',
    '/account/settings',
    '/account/personal',
    `/plans/${planId}/attendance`,
    '/find-tutor',
    `/find-tutor/${id}`,
    '/post-requirement',
    '/requirements',
    '/requirements/transfer-requests',
    '/attendance',
    'attendance',
    '/inbox'
  ];

  if (paths.includes(path) && window.innerWidth < 768) {
    return (
      <div
        ref={headerRef}
        className={`fixed ${showHeader.show ? 'top-0' : '-top-14 md:-top-16'
          } transition-all w-full  mx-auto bg-white drop-shadow-md z-50`}
      >
        <div className="relative container h-14 md:h-16 mx-auto  flex items-center ">
          <div
            onClick={() => navigate(-1)}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-neutralBlue2 p-2 cursor-pointer"
          >
            <img src={BACK_ARROW} className="" />
          </div>
          <div className="px-4">
            <BreadCrumb />
          </div>
        </div>
      </div>
    );
  }

  if (sidebarOpen) {
    return (
      <div className="w-full h-full flex flex-col gap-4 my-[10%] px-7">
        <div className="flex items-start">
          <div className="w-20 h-20 rounded-full overflow-hidden">
            <img src={userData?.profilePic || DEFAULT_PROFILE_PIC} className="w-full h-full object-cover" loading="lazy" />
          </div>
        </div>
        <div className="w-full flex flex-col gap-1">
          <h3 className="text-2xl font-semibold">{userData?.name}</h3>
          <p className="text-sm text-neutralGray2">{userData?.email}</p>
        </div>
        <div className="container flex flex-col gap-7 justify-center mt-10">
          <Link to="/account" onClick={() => onCloseSidebar()}>
            <div className="flex items-center gap-4">
              <img src={PERSON_ICON} />
              <h3 className="text-base font-medium">Profile</h3>
            </div>
          </Link>
          <Link to="/account/transactions" onClick={() => onCloseSidebar()}>
            <div className="flex items-center gap-4">
              <img src={RECEIPT_ICON} />
              <h3 className="text-base font-medium">Transactions and Receipts</h3>
            </div>
          </Link>
          <Link to="/account/settings" onClick={() => onCloseSidebar()}>
            <div className="flex items-center gap-4">
              <img src={SETTINGS_ICON} />
              <h3 className="text-base font-medium">Settings</h3>
            </div>
          </Link>
          <Link to="/account/feedback" onClick={() => onCloseSidebar()}>
            <div className="flex items-center gap-4">
              <img src={FEEDBACK_ICON} />
              <h3 className="text-base font-medium">Share feedback</h3>
            </div>
          </Link>
          <div className="mt-20 flex items-center gap-4 cursor-pointer" onClick={() => logout()}>
            <img src={LOGOUT_ICON} alt="Logout icon" className="w-4" />
            <p className="text-base font-medium">Logout</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        ref={headerRef}
        className={`fixed ${showHeader.show ? 'top-0' : '-top-14 md:-top-16'
          } transition-all w-full  mx-auto bg-white drop-shadow-md z-50`}
      >
        <div className="relative container h-14 md:h-16 mx-auto  flex items-center ">
          <Link to="/" className="hidden lg:flex">
            <img src={NAV_LOGO} alt="WOT Logo" className="h-8" />
          </Link>

          <div className="w-full h-full flex items-center justify-between md:ml-20">
            <div className="hidden md:flex gap-2 items-center relative w-full max-w-[350px] py-2 px-4 bg-neutralBlue2 border rounded-full">
              {/* input div */}
              <img src={SEARCH_SVG} alt="Search icon" className="w-4 mr-1" />
              <form
                className="w-full flex items-center"
                onSubmit={() => navigate(`/search/${capitalizeFirstLetter(searchTerm)}`)}
              >
                <input
                  type="text"
                  placeholder="Search"
                  className="w-full text-sm focus:outline-none bg-transparent"
                  onChange={(e) => {
                    setSearchTerm((e.target as HTMLInputElement).value);
                  }}
                />
              </form>
              {/* <div className="px-4 border-l-2 border-neutralGray3">
            <SearchDropDown
              label="Subject"
              value={subject}
              icon={ARROWDOWN_ICON}
              children={dropDownOptions.map((sub, i) => (
                <p key={i} className="py-2 px-4 hover:bg-neutralBlue1" onClick={() => setSubject(sub)}>
                  {sub}
                </p>
              ))}
            />
          </div> */}
            </div>
            <div className="w-full md:w-min h-full flex items-center md:ml-auto">
              <div className="h-full hidden md:flex justify-center">
                <div className="flex items-center px-4 gap-5">
                  <Link to="/dashboard">
                    <p className="text-base font-medium hover:text-primary">Dashboard</p>
                  </Link>

                  <div className="w-full group h-full  flex items-center">
                    <div className="text-base font-normal flex items-center justify-center gap-2 cursor-pointer">
                      <p className="text-base font-medium hover:text-primary">Tutor</p>
                      <MdKeyboardArrowDown className="text-base" />
                    </div>

                    <div className="absolute hidden bg-white border rounded-md pt-1 w-full min-h-[250px] left-0 top-16 group-hover:flex">
                      <div className="lg:w-4/5 lg:mx-auto w-full py-8 lg:flex lg:flex-row lg:gap-40 flex flex-col gap-0">
                        <div className="min-w-[256px] flex flex-col justify-start shrink-0">
                          <Link to="/find-tutor">
                            <div className="flex items-center justify-between px-4 py-7 bg-white hover:bg-neutralBlue2 rounded basis-1/5 cursor-pointer">
                              <span className="text-lg font-medium">Browse and find tutors</span>
                              <div>
                                <img src={ARROWDOWN_ICON} alt="Arrow Icon" className="-rotate-90" />
                              </div>
                            </div>
                          </Link>

                          <Link to="/post-requirement">
                            <div className="flex items-center justify-between px-4 py-7 bg-white hover:bg-neutralBlue2 rounded basis-1/5 cursor-pointer">
                              <span className="text-lg font-medium">Post a requirement</span>
                              <div>
                                <img src={ARROWDOWN_ICON} alt="Arrow Icon" className="-rotate-90" />
                              </div>
                            </div>
                          </Link>

                          <Link to="/requirements">
                            <div className="flex items-center justify-between px-4 py-7 bg-white hover:bg-neutralBlue2 rounded basis-1/5 cursor-pointer">
                              <span className="text-lg font-medium">My requirements</span>
                              <div>
                                <img src={ARROWDOWN_ICON} alt="Arrow Icon" className="-rotate-90" />
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="w-full flex flex-col">
                          <div className="py-2 lg:px-0 px-4">
                            <span className="text-base font-medium">Browse by Subject</span>
                            <div className="w-full flex flex-wrap max-h-[80px] overflow-hidden gap-4 py-2 border-b-2 border-neutralGray3">
                              {subjects &&
                                subjects.map((item: any, i) => (
                                  <p
                                    onClick={() =>
                                      navigate('/find-tutor', {
                                        state: {
                                          categoryType: 'subject',
                                          name: item.category?.name
                                        }
                                      })
                                    }
                                    className="hover:text-primary cursor-pointer"
                                    key={i}
                                  >
                                    {item?.category?.name}
                                  </p>
                                ))}
                            </div>
                          </div>
                          <div className="py-2 lg:px-0 px-4">
                            <span className="text-base font-medium">Browse by Hobbies</span>
                            <div className="w-full flex flex-wrap max-h-[80px] overflow-hidden gap-4 py-2 border-b-2 border-neutralGray3">
                              {hobbies &&
                                hobbies.map((item: any, i) => (
                                  <p
                                    onClick={() =>
                                      navigate('/find-tutor', {
                                        state: {
                                          categoryType: 'hobby',
                                          name: item.category?.name
                                        }
                                      })
                                    }
                                    className="hover:text-primary cursor-pointer"
                                    key={i}
                                  >
                                    {item?.category?.name}
                                  </p>
                                ))}
                            </div>
                          </div>
                          <div className="py-2 lg:px-0 px-4">
                            <span className="text-base font-medium">Browse by Skill Development</span>
                            <div className="w-full flex flex-wrap max-h-[80px] overflow-hidden gap-4 py-2">
                              {skills &&
                                skills.map((item: any, i) => (
                                  <p
                                    onClick={() =>
                                      navigate('/find-tutor', {
                                        state: {
                                          categoryType: 'skill',
                                          name: item.category?.name
                                        }
                                      })
                                    }
                                    className="hover:text-primary cursor-pointer"
                                    key={i}
                                  >
                                    {item?.category?.name}
                                  </p>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <MenuDropDown
                    options={[
                      {
                        id: 1,
                        name: 'My Calendar',
                        link: '/my-calender'
                      },
                      {
                        id: 2,
                        name: 'My Attendance',
                        link: '/attendance'
                      }
                    ]}
                    title="My Calender"
                  />

                  <Link to={'/my-plans'}>
                    <p className="text-base font-medium hover:text-primary">Plans</p>
                  </Link>
                </div>
              </div>

              <div className="hidden md:flex gap-4 px-4">
                <Link to={'/inbox'}>
                  <Inbox />
                </Link>
                <Link to={'/notifications'}>
                  <Notifications />
                </Link>
                <Tooltip title="My account" arrow>
                  <Link to="/account">
                    <div className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer">
                      <img
                        src={userData?.profilePic === '' ? DEFAULT_PROFILE_PIC : userData?.profilePic}
                        alt="User Pic"
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>
                  </Link>
                </Tooltip>
              </div>

              <div className="md:hidden w-full flex justify-between gap-4 px-4 ">
                <Tooltip title="My account" arrow>
                  <div onClick={() => onOpenSidebar()} className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer">
                    <img
                      src={userData?.profilePic === '' ? DEFAULT_PROFILE_PIC : userData?.profilePic}
                      alt="User Pic"
                      className="w-full h-full object-cover rounded-full"
                    />
                  </div>
                </Tooltip>
                <div className="flex gap-4 ml-auto">
                  <Link to={'/inbox'}>
                    <Inbox />
                  </Link>
                  <Link to={'/notifications'}>
                    <Notifications />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!sidebarOpen && window.innerWidth < 768 && <BottomNav />}
    </>
  );
}

export const Inbox = () => {
  const [count, setCount] = useState(0);
  const { userData } = useAppSelector((state) => state.userSlice);

  async function getUnReadMessages(): Promise<any> {
    return await xhr({
      url: `/${userData?._id}/unread-messages`,
      method: 'GET'
    })
      .then((res) => {
        return res.data;
      })
      .catch((err: ApiError) => {
        throw err;
      });
  }

  useEffect(() => {
    getUnReadMessages()
      .then((data) => {
        setCount(data);
      })
      .catch((err) => err);
  }, []);

  return (
    <div className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer">
      <img src={MESSAGE_SVG} alt="Messages" className="w-4" />
      {count > 0 ? (
        <span className="absolute -right-1 -top-2 w-2 h-2 flex items-center justify-center bg-secondary text-white text-xs p-2 rounded-full">
          {count}
        </span>
      ) : null}
    </div>
  );
};

function Notifications() {
  const [count, setCount] = useState(0);
  const { userData } = useAppSelector((state) => state.userSlice);

  async function getUnReadNotifications(): Promise<any> {
    if (!userData?._id) return;
    return await notificationsApi.get(userData?._id).then((data) => data.filter((i: any) => i.read === false).length);
  }

  useEffect(() => {
    getUnReadNotifications()
      .then((data) => {
        setCount(data);
      })
      .catch((err) => err);
  }, []);

  return (
    <div className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer">
      <img src={NOTIFICATIONS_SVG} alt="Notifications" className="w-4" />
      {count > 0 ? (
        <span className="absolute -right-1 -top-2 w-2 h-2 flex items-center justify-center bg-secondary text-white text-xs p-2 rounded-full">
          {count}
        </span>
      ) : null}
    </div>
  )
}

export default Header;
